import { useEffect, useRef } from 'react';
import { useOverlayContext } from "../../../contexts";
import { handleRequest } from "../../../infra/utils";
import { useStoreActions } from "../../../store/store-context";
import { EditDocumentModal } from "../EditDocumentModal/EditDocumentModal";
import { jsx as _jsx } from "react/jsx-runtime";
export const useEditQuillLegalTerms = params => {
  const {
    showModal,
    showErrorToast
  } = useOverlayContext();
  const {
    api
  } = useStoreActions();
  const localContentByTermId = useRef(new Map());
  useEffect(() => {
    localContentByTermId.current.clear();
  }, [params === null || params === void 0 ? void 0 : params.resetKey]);
  const editQuillLegalTerms = async (legalTerm, variant) => {
    let initialContent;
    const cachedContent = localContentByTermId.current.get(legalTerm.id);
    if (cachedContent) {
      initialContent = cachedContent;
    } else if (variant.type === 'local' && legalTerm.richTextId && variant.sourceId) {
      const result = await handleRequest(api.texts.getLegalTermsRichTextContent(variant.sourceId, legalTerm.richTextId));
      if (!result.success) {
        showErrorToast('Failed to load document content.');
        return;
      }
      initialContent = {
        type: 'quill-delta',
        value: result.data.value
      };
    } else {
      initialContent = {
        type: 'quill-delta',
        value: legalTerm.richTextContent
      };
    }
    const handleLocalSave = content => {
      var _params$onLocalSave;
      localContentByTermId.current.set(legalTerm.id, content);
      params === null || params === void 0 || (_params$onLocalSave = params.onLocalSave) === null || _params$onLocalSave === void 0 || _params$onLocalSave.call(params, legalTerm.id, content);
    };
    await showModal({
      closeOnEscapeKey: true,
      closeOnClickOutside: true,
      content: _ref => {
        let {
          dismissModal
        } = _ref;
        return /*#__PURE__*/_jsx(EditDocumentModal, {
          variant: variant,
          legalTermsId: legalTerm.id,
          initialName: legalTerm.name,
          initialContent: initialContent,
          usedIn: legalTerm.contentType === 'quill' ? legalTerm.usedIn : undefined,
          onLocalSave: handleLocalSave,
          dismissModal: dismissModal
        });
      }
    });
  };
  return {
    editQuillLegalTerms
  };
};